import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {UserNamespace} from '@namespaces/user.namespace';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {EventsService} from '@services/events.service';
import {TechnicalDeviceDocumentApiService} from '@api/technical-device-document.api.service';
import {PreviewModalService} from '@services/preview-modal.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-documentation-list-item',
    templateUrl: './documentation-list-item.component.html',
})
export class DocumentationListItemComponent implements OnInit {

    @Input() doc: TechnicalDeviceNamespace.DeviceDocumentation;

    @Input() isFetching = false;

    public permissions = UserNamespace.Permission;

    @HostBinding() private className = 'tab-list-item';

    constructor(
        private deviceService: TechnicalDeviceDataService,
        private events: EventsService,
        private documentApi: TechnicalDeviceDocumentApiService,
        private filesPreviewService: PreviewModalService,
    ) {
    }

    ngOnInit() {
    }

    onShowFileClick() {
        this.filesPreviewService.show({
            files: this.doc.files,
        });
    }

    onRemoveClick() {
        this.events.showConfirm({
            title: `Вы уверены что хотите удалить документ «${this.doc.name}»?`,
            confirmButtonTitle: 'Удалить'
        }).subscribe(() => {
            this.documentApi.delete({
                id: this.doc.id
            }).subscribe(() => {
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.technicalDeviceDocumentationRemovedMessage
                });

                this.deviceService.documentationRemoved$.next();
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.technicalDeviceDocumentationRemovedFailMessage
                });
            });
        }, () => {

        });
    }

}
